import {
  mainCategoryCreateSchema,
  mainCategorySchema,
} from "@/schema/console/regular-assessments/MainCategory";
import { z } from "zod";

export const regularAssessmentDetailSchema = z.object({
  id: z.number(),
  main_categories: z.array(mainCategorySchema),
});

export const RegularAssessmentCreateSchema = z.object({
  is_premium: z.literal(true),
  is_published: z.boolean(),
  main_categories: z.array(mainCategoryCreateSchema),
});

export type RegularAssessmentDetail = z.infer<
  typeof regularAssessmentDetailSchema
>;

export type RegularAssessmentCreate = z.infer<
  typeof RegularAssessmentCreateSchema
>;
